// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../../../index.mjs";
export const TypeReference = {
    list: (value) => {
        return {
            value: value,
            type: "list",
            _visit: function (visitor) {
                return FernIr.dynamic.TypeReference._visit(this, visitor);
            },
        };
    },
    literal: (value) => {
        return {
            value: value,
            type: "literal",
            _visit: function (visitor) {
                return FernIr.dynamic.TypeReference._visit(this, visitor);
            },
        };
    },
    map: (value) => {
        return Object.assign(Object.assign({}, value), { type: "map", _visit: function (visitor) {
                return FernIr.dynamic.TypeReference._visit(this, visitor);
            } });
    },
    named: (value) => {
        return {
            value: value,
            type: "named",
            _visit: function (visitor) {
                return FernIr.dynamic.TypeReference._visit(this, visitor);
            },
        };
    },
    nullable: (value) => {
        return {
            value: value,
            type: "nullable",
            _visit: function (visitor) {
                return FernIr.dynamic.TypeReference._visit(this, visitor);
            },
        };
    },
    optional: (value) => {
        return {
            value: value,
            type: "optional",
            _visit: function (visitor) {
                return FernIr.dynamic.TypeReference._visit(this, visitor);
            },
        };
    },
    primitive: (value) => {
        return {
            value: value,
            type: "primitive",
            _visit: function (visitor) {
                return FernIr.dynamic.TypeReference._visit(this, visitor);
            },
        };
    },
    set: (value) => {
        return {
            value: value,
            type: "set",
            _visit: function (visitor) {
                return FernIr.dynamic.TypeReference._visit(this, visitor);
            },
        };
    },
    unknown: () => {
        return {
            type: "unknown",
            _visit: function (visitor) {
                return FernIr.dynamic.TypeReference._visit(this, visitor);
            },
        };
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "list":
                return visitor.list(value.value);
            case "literal":
                return visitor.literal(value.value);
            case "map":
                return visitor.map(value);
            case "named":
                return visitor.named(value.value);
            case "nullable":
                return visitor.nullable(value.value);
            case "optional":
                return visitor.optional(value.value);
            case "primitive":
                return visitor.primitive(value.value);
            case "set":
                return visitor.set(value.value);
            case "unknown":
                return visitor.unknown();
            default:
                return visitor._other(value);
        }
    },
};
